import axios from 'axios'
import { getAuthHeader, getMultiPartAuthHeader } from './config'

const prefixURL = '/api'

const getAll = async (courseId, assessmentId) => {
  const response = await axios.get(
    `${prefixURL}/${courseId}/assessments/${assessmentId}/submissions/`,
    getAuthHeader()
  )
  return response.data
}

const getOrCreateSumbission = async (courseId, assessmentId, studentId) => {
  const response = await axios.get(
    `${prefixURL}/${courseId}/assessments/${assessmentId}/submissions/${studentId}`,
    getAuthHeader()
  )
  return response.data
}

const updateSubmission = async (
  courseId,
  assessmentId,
  studentId,
  submission
) => {
  const formData = new FormData()

  if (submission.files && submission.files.length > 0) {
    submission.files.forEach((file, index) => {
      if (file.originFileObj) {
        formData.append('files', file.originFileObj)
      }
    })

    const existingFiles = submission.files
      .filter((file) => !file.originFileObj && file.url)
      .map(({ name, url, _id }) => ({ name, url, _id }))

    formData.append('existingFiles', JSON.stringify(existingFiles))
  }

  const submissionData = { ...submission }
  delete submissionData.files

  formData.append('submissionData', JSON.stringify(submissionData))

  const response = await axios.put(
    `${prefixURL}/${courseId}/assessments/${assessmentId}/submissions/${studentId}`,
    formData,
    getMultiPartAuthHeader()
  )
  return response.data
}

const deleteSubmissionFile = async (
  courseId,
  assessmentId,
  studentId,
  fileUrl
) => {
  const response = await axios.delete(
    `${prefixURL}/${courseId}/assessments/${assessmentId}/submissions/${studentId}/files`,
    {
      data: { fileUrl },
      ...getAuthHeader()
    }
  )
  return response.data
}

const checkPlagiarism = async (courseId, assessmentId) => {
  const response = await axios.get(
    `${prefixURL}/${courseId}/assessments/${assessmentId}/check-plagiarism`,
    getAuthHeader()
  )
  return response.data
}

const autoGrade = async (courseId, assessmentId) => {
  const response = await axios.get(
    `${prefixURL}/${courseId}/assessments/${assessmentId}/auto-grade`,
    getAuthHeader()
  )
  return response.data
}

const gradeSubmission = async (
  courseId,
  assessmentId,
  studentId,
  submission
) => {
  const response = await axios.put(
    `${prefixURL}/${courseId}/assessments/${assessmentId}/submissions/${studentId}/grade`,
    submission,
    getAuthHeader()
  )
  return response.data
}

const submissionService = {
  getAll,
  getOrCreateSumbission,
  updateSubmission,
  deleteSubmissionFile,
  gradeSubmission,
  checkPlagiarism,
  autoGrade
}

export default submissionService
